import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import guestService from "../../services/guestService";

export const getTaxShippingCharges = createAsyncThunk(
    "cart/getTaxShippingCharges",
    async () => {
        const response = await guestService.getTaxShippingCharges();
        return response.data.data;
    }
);

const initialState = {
    loading: false,
    cartItems: localStorage.getItem("cartItems") ? JSON.parse(localStorage.getItem("cartItems")) : [],
    cartTotalQty: localStorage.getItem("cartTotalQty") ? JSON.parse(localStorage.getItem("cartTotalQty")) : 0,
    cartTotalAmount: 0,
    cartShipping: localStorage.getItem("cartShipping") ? JSON.parse(localStorage.getItem("cartShipping")) : 0,
    cartTaxPercentage: 0,
    cartTax: 0,
    cartGrandTotal: 0
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        add(state, action) {
            const itemIndex = state.cartItems.findIndex((item) => item.id === action.payload.item.id);
            if (itemIndex >= 0) {
                if(!action.payload.isJoiningPackage) {
                    state.cartItems[itemIndex].cartQty += 1
                }
            } else {
                const tempProduct = { 
                    ...action.payload.item, 
                    cartQty: 1, 
                    prodColor: action.payload.color, 
                    prodSize: action.payload.size, 
                    isPackage: action.payload.isPackage, 
                    isVipPackage: action.payload.isVipPackage,
                    isJoiningPackage: action.payload.isJoiningPackage
                }
                state.cartItems.push(tempProduct)
            }

            localStorage.setItem("cartItems", JSON.stringify(state.cartItems))

            let { total, quantity, shipping } = state.cartItems.reduce((cartTotal, cartItem) => {
                const { price, cartQty, shipping_charges } = cartItem;
                const itemTotal = price * cartQty;

                cartTotal.total += itemTotal;
                cartTotal.quantity += cartQty;
                cartTotal.shipping += Number(shipping_charges);

                return cartTotal;
            },
            {
                total: 0,
                quantity: 0,
                shipping: 0
            });

            state.cartTotalQty = quantity;
            state.cartTotalAmount = total;
            state.cartShipping = shipping;

            localStorage.setItem("cartTotalQty", JSON.stringify(state.cartTotalQty))
            localStorage.setItem("cartTotalAmount", JSON.stringify(state.cartTotalAmount))
            localStorage.setItem("cartShipping", JSON.stringify(state.cartShipping))
        },
        remove(state, action) {
            const nextCartItems = state.cartItems.filter((item) => item.id !== action.payload.id)
            state.cartItems = nextCartItems;

            localStorage.setItem("cartItems", JSON.stringify(state.cartItems))

            let { total, quantity, shipping } = state.cartItems.reduce((cartTotal, cartItem) => {
                const { price, cartQty, shipping_charges } = cartItem;
                const itemTotal = price * cartQty;

                cartTotal.total += itemTotal;
                cartTotal.quantity += cartQty;
                cartTotal.shipping += Number(shipping_charges);

                return cartTotal;
            },
            {
                total: 0,
                quantity: 0,
                shipping: 0
            });

            state.cartTotalQty = quantity;
            state.cartTotalAmount = total;
            state.cartShipping = shipping;

            localStorage.setItem("cartTotalQty", JSON.stringify(state.cartTotalQty))
            localStorage.setItem("cartTotalAmount", JSON.stringify(state.cartTotalAmount))
            localStorage.setItem("cartShipping", JSON.stringify(state.cartShipping))
        },
        decrease(state, action) {
            const itemIndex = state.cartItems.findIndex((item) => item.id === action.payload.id)
            if(state.cartItems[itemIndex].cartQty > 1) {
                state.cartItems[itemIndex].cartQty -= 1
            } else if(state.cartItems[itemIndex].cartQty === 1) {
                const nextCartItems = state.cartItems.filter((item) => item.id !== action.payload.id)
                state.cartItems = nextCartItems;
            }

            localStorage.setItem("cartItems", JSON.stringify(state.cartItems))

            let { total, quantity, shipping } = state.cartItems.reduce((cartTotal, cartItem) => {
                const { price, cartQty, shipping_charges } = cartItem;
                const itemTotal = price * cartQty;

                cartTotal.total += itemTotal;
                cartTotal.quantity += cartQty;
                cartTotal.shipping += Number(shipping_charges);

                return cartTotal;
            },
            {
                total: 0,
                quantity: 0,
                shipping: 0
            });

            state.cartTotalQty = quantity;
            state.cartTotalAmount = total;
            state.cartShipping = shipping;

            localStorage.setItem("cartTotalQty", JSON.stringify(state.cartTotalQty))
            localStorage.setItem("cartTotalAmount", JSON.stringify(state.cartTotalAmount))
            localStorage.setItem("cartShipping", JSON.stringify(state.cartShipping))
        },
        clear(state, action) {
            state.cartItems = [];
            state.cartTotalQty = 0;
            state.cartTotalAmount = 0;
            state.cartShipping = 0;

            localStorage.setItem("cartItems", JSON.stringify(state.cartItems))
            localStorage.setItem("cartTotalQty", JSON.stringify(state.cartTotalQty))
            localStorage.setItem("cartTotalAmount", JSON.stringify(state.cartTotalAmount))
            localStorage.setItem("cartShipping", JSON.stringify(state.cartShipping))
        },
        getTotals(state, action) {
            let { total, quantity } = state.cartItems.reduce((cartTotal, cartItem) => {
                const { price, cartQty } = cartItem;
                const itemTotal = price * cartQty;

                cartTotal.total += itemTotal;
                cartTotal.quantity += cartQty;

                return cartTotal;
            },
            {
                total: 0,
                quantity: 0
            });

            state.cartTotalQty = quantity;
            state.cartTotalAmount = total;
        },
        getGrandTotal(state, action) {
            state.cartGrandTotal = state.cartShipping + state.cartTax + state.cartTotalAmount;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTaxShippingCharges.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getTaxShippingCharges.fulfilled, (state, action) => {
            state.loading = false;
            state.cartShipping = state.cartShipping;
            state.cartTaxPercentage = Number(action.payload.tax);
            state.cartTax = (Number(action.payload.tax) / 100) * state.cartTotalAmount;
        });
        builder.addCase(getTaxShippingCharges.rejected, (state, action) => {
            state.loading = false;
        });
    }
});

export const { add, remove, decrease, clear, getTotals, getGrandTotal } = cartSlice.actions;
export default cartSlice.reducer;
